"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const controlComputeIsDynamicLoadingFlagAfterUpdate_1 = __importDefault(require("../../shared/controlComputeIsDynamicLoadingFlagAfterUpdate"));
const updateControlsArrayByPath = ({ // eslint-disable-line
controls, path, dataToUpdate, updatedControls = [], shouldNotResetDynamicLoadingEnabled, }) => {
    const [currentIndex, ...restOfPath] = path;
    const newControls = [...controls];
    if (restOfPath.length === 0) {
        const currentControl = controls[currentIndex];
        const newControl = Object.assign(Object.assign(Object.assign({}, currentControl), { isDynamicLoadingEnabled: (0, controlComputeIsDynamicLoadingFlagAfterUpdate_1.default)({
                original: currentControl.isDynamicLoadingEnabled,
                shouldNotResetDynamicLoadingEnabled,
            }) }), dataToUpdate);
        newControls[currentIndex] = newControl;
        return {
            controls: newControls,
            updatedControls: [...updatedControls, newControl],
            lastUpdated: newControl,
        };
    }
    const { controls: updatedControlChildren, updatedControls: newUpdatedControls, } = updateControlsArrayByPath({
        controls: newControls[currentIndex].controls || [],
        path: restOfPath,
        dataToUpdate,
        updatedControls,
        shouldNotResetDynamicLoadingEnabled,
    });
    newControls[currentIndex] = Object.assign(Object.assign({}, newControls[currentIndex]), { controls: updatedControlChildren });
    return {
        controls: newControls,
        updatedControls: [...newUpdatedControls, newControls[currentIndex]],
    };
};
exports.default = updateControlsArrayByPath;
